var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsappDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.728,
    height: 27.728,
    viewBox: "0 0 27.728 27.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12210",
    "data-name": "Group 12210",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49656",
    "data-name": "Path 49656",
    d: "M13.867,0h-.007A13.855,13.855,0,0,0,2.639,21.99L.912,27.141l5.329-1.7A13.862,13.862,0,1,0,13.867,0Z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49657",
    "data-name": "Path 49657",
    d: "M123.39,130.325a3.912,3.912,0,0,1-2.721,1.957c-.724.154-1.671.277-4.856-1.043-4.074-1.688-6.7-5.828-6.9-6.1a7.918,7.918,0,0,1-1.646-4.182,4.426,4.426,0,0,1,1.418-3.374,2.014,2.014,0,0,1,1.418-.5c.172,0,.326.009.464.016.407.017.612.042.88.685.334.806,1.149,2.8,1.246,3a.825.825,0,0,1,.059.75,2.4,2.4,0,0,1-.449.636c-.2.236-.4.416-.6.669-.187.22-.4.456-.163.863a12.306,12.306,0,0,0,2.249,2.8,10.192,10.192,0,0,0,3.251,2.005.877.877,0,0,0,.977-.154,16.768,16.768,0,0,0,1.083-1.435.774.774,0,0,1,.995-.3c.374.13,2.355,1.109,2.762,1.312s.676.3.775.473A3.453,3.453,0,0,1,123.39,130.325Z",
    transform: "translate(-101.455 -110.747)",
    fill: "#fafafa"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappDoc);
export default __webpack_public_path__ + "static/media/whatsappDoc.33387fb67192522dbc5e0e3beda9e6a1.svg";
export { ForwardRef as ReactComponent };